const styles = theme => ({
  main: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px',
    borderBottom: '2px solid ' + theme.palette.primary.light
  },
  titleButton: {
    textTransform: 'none'
  },
  localization: {
    marginLeft: theme.spacing(1)
  }
})

export default styles
